<template>
	<button @click="handlerFunc" class="button" :disabled="disabled">
		<slot v-if="!preloader"></slot>
		<div v-else class="button__preloader">
			<svg class="button__preloader-icon" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M15.1891 21.8149C15.4758 22.6973 14.9931 23.6577 14.0793 23.8185C12.4031 24.1134 10.6766 24.0494 9.01572 23.623C6.81012 23.0567 4.81118 21.8745 3.25238 20.2146C1.69357 18.5546 0.639246 16.4854 0.212553 14.2486C-0.21414 12.0118 0.00441207 9.69973 0.842682 7.58251C1.68095 5.46528 3.10433 3.63026 4.94658 2.2918C6.78882 0.953328 8.97387 0.166662 11.2465 0.0236793C13.5192 -0.119303 15.7856 0.387301 17.781 1.48432C19.2837 2.31042 20.586 3.44565 21.6061 4.8081C22.1622 5.55084 21.8566 6.58131 21.0435 7.0283C20.2304 7.47529 19.22 7.16451 18.6243 6.45313C17.9394 5.63517 17.1057 4.94733 16.1624 4.42871C14.7256 3.63886 13.0938 3.2741 11.4575 3.37705C9.82119 3.48 8.24795 4.0464 6.92154 5.01009C5.59512 5.97379 4.57029 7.295 3.96673 8.8194C3.36318 10.3438 3.20582 12.0085 3.51304 13.619C3.82026 15.2295 4.57937 16.7193 5.70171 17.9145C6.82405 19.1097 8.26329 19.9608 9.85132 20.3686C10.894 20.6363 11.9726 20.7056 13.0318 20.5782C13.953 20.4674 14.9023 20.9325 15.1891 21.8149Z" fill="black"/>
			</svg>
		</div>
	</button>
</template>
<script setup>
import {
	defineProps,
	ref,
} from 'vue';

const props = defineProps({
	handler: {
		type: Function,
		default: () => ({}),
	},
	isPreloader: {
		type: Boolean,
		default: false,
	},
});

const disabled = ref(false);
const preloader = ref(false);

const handlerFunc = async () => {
	if (props.isPreloader) {
		preloader.value = true;
	}
	disabled.value = true;
	console.log('disabled', disabled.value);
	await props.handler();
	disabled.value = false;
	console.log('disabled', disabled.value);
	if (props.isPreloader) {
		preloader.value = false;
	}
};
</script>
<style lang="scss">
@import './button';
</style>
